<template>
  <div class="flip-container w-full h-full">
    <div class="flip-card w-full h-full">
      <div class="flip-card-inner w-full h-full">
        <div class="flip-card-front w-full h-full">
          <slot name="front-content"></slot>
        </div>
        <div class="flip-card-back w-full h-full">
          <slot name="back-content"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FlipCard'
}
</script>

<style scoped>
.flip-container {
  perspective: 1000px;
}

.flip-card {
  position: relative;
  width: 100%;
  height: 100%;
}

.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
}

.flip-container:hover .flip-card-inner {
  transform: rotateY(180deg);
}

.flip-card-front,
.flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
}

.flip-card-front {
  z-index: 2;
}

.flip-card-back {
  transform: rotateY(180deg);
}
</style>
